import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Draggable from "react-draggable";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import { green, orange, red, grey } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import moment from "moment";
import styles from "./ClossingMassEditor.module.css";

const ClossingMassEditor = (props) => {
    const [dateStart, setDateStart] = useState(moment().startOf("day"));
    const [dateEnd, setDateEnd] = useState(moment().add(1, "d").startOf("day"));
    const [massDays, setMassDays] = useState(dateEnd.diff(dateStart, "d"));
    const [changeArms, setChangeArms] = useState(false);

    const onChangeDateStart = (e) => {
        let newDate = moment(e.target.value);
        if (newDate.isAfter(dateEnd)) {
            alert("Дата начала не может быть позже даты окончания");
            setDateStart(dateEnd.clone().subtract(1, "d").startOf("day"));
        } else {
            setDateStart(newDate);
        }
    };

    const onChangeDateEnd = (e) => {
        let newDate = moment(e.target.value);
        if (newDate.isBefore(dateStart)) {
            alert("Дата окончания не может быть раньне даты начала");
            setDateEnd(dateStart.clone().add(1, "d").startOf("day"));
        } else {
            setDateEnd(newDate);
        }
    };

    let start = 0;

    useEffect(() => {
        setMassDays(dateEnd.diff(dateStart, "d"));
        if (start > 0) {
            setChangeArms(true);
        }
        start++;
    }, [dateStart, dateEnd]);

    const days = [dateStart.format("YYYY-MM-DD")];
    let daysSet = dateStart.clone();

    if (massDays < 2000) {
        for (let i = 0; i < massDays; i++) {
            days.push(daysSet.add(1, "d").format("YYYY-MM-DD"));
        }
    }

    let outputDays = days;

    useEffect(() => {
        if (props.selectedCells().length > 0 && !changeArms) {
            outputDays = props.selectedCells();
            setDateStart(moment(props.selectedCells()[0]));
            setDateEnd(
                moment(props.selectedCells()[props.selectedCells().length - 1]),
            );
        }
    }, []);

    const inputDate = {
        marginLeft: "5px",
        backgroundColor: "#26ade4",
        color: "white",
        border: "none",
        outline: "none",
        borderRadius: "5px",
        padding: "10px",
        fontFamily: "Roboto",
        fontSize: "15px",
    };

    const newValueCss = {
        width: "60px",
    };

    return (
        <div>
            <Dialog
                open={props.isVisible}
                onClose={() => props.setIsOpenMassClossingHandler(false)}
                aria-labelledby="draggable-dialog-title"
                maxWidth="xl"
            >
                <DialogTitle
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    Массовое открытие\закрытие продаж тарифа:
                    <br />
                    <b>{props.rateName}</b>
                </DialogTitle>
                <form onSubmit={props.onSubmit}>
                    <div style={{ display: "flex" }}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                minWidth: "40%",
                            }}
                        >
                            {props.roomTypes &&
                                props.roomTypes.map((t) => (
                                    <div
                                        className={styles.checkboxContainer}
                                        key={t.id}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            margin: "5px 15px",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id={t.id}
                                            defaultChecked="true"
                                        />
                                        <label
                                            style={{ paddingLeft: "5px" }}
                                            htmlFor={t.id}
                                        >
                                            {t.name}
                                        </label>
                                    </div>
                                ))}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                padding: "0 10px",
                            }}
                        >
                            <div style={{ marginBottom: "10px" }}>
                                <label htmlFor="dateMassStart">
                                    Дата начала
                                </label>
                                <input
                                    style={inputDate}
                                    onChange={onChangeDateStart}
                                    type="date"
                                    id="dateMassStart"
                                    value={dateStart.format("YYYY-MM-DD")}
                                />
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <label htmlFor="dateMassEnd">
                                    Дата окончания
                                </label>
                                <input
                                    style={inputDate}
                                    onChange={onChangeDateEnd}
                                    type="date"
                                    id="dateMassEnd"
                                    value={dateEnd.format("YYYY-MM-DD")}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    flexWrap: "wrap",
                                    marginBottom: "10px",
                                }}
                            >
                                {outputDays.map((d) => (
                                    <div
                                        className={styles.checkboxContainer}
                                        key={d}
                                        style={{
                                            border: "1px solid pink",
                                            borderRadius: "5px",
                                            padding: "5px",
                                            margin: "2px",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id={d}
                                            defaultChecked="true"
                                        />
                                        <label
                                            style={{ marginLeft: "5px" }}
                                            htmlFor={d}
                                        >
                                            {d}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <fieldset
                                style={{
                                    marginBottom: "10px",
                                    borderRadius: "5px",
                                }}
                            >
                                <legend>Действие с периодом продаж</legend>
                                <div>
                                    <input
                                        type="radio"
                                        id="closeMassSales"
                                        style={newValueCss}
                                        defaultChecked={true}
                                        name="massClossing"
                                    />
                                    <label htmlFor="closeMassSales">
                                        Закрыть продажи
                                    </label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="openMassSales"
                                        style={newValueCss}
                                        name="massClossing"
                                    />
                                    <label htmlFor="openMassSales">
                                        Открыть продажи
                                    </label>
                                </div>
                            </fieldset>
                            <div style={{ marginTop: "20px" }}>
                                <Button
                                    onClick={() =>
                                        props.setIsOpenMassClossingHandler(
                                            false,
                                        )
                                    }
                                    color="primary"
                                    variant="contained"
                                    endIcon={<ArrowBackIcon />}
                                    style={{
                                        backgroundColor: orange[500],
                                        margin: "10px",
                                    }}
                                >
                                    Вернуться
                                </Button>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    endIcon={<SaveIcon />}
                                    style={{
                                        backgroundColor: green[500],
                                        margin: "10px",
                                    }}
                                    type="submit"
                                >
                                    Сохранить
                                </Button>
                            </div>
                        </div>
                    </div>
                </form>
            </Dialog>
        </div>
    );
};

export default ClossingMassEditor;
